//
// Generated class TipPoolTag
//

/// <reference path="TipPoolTag_ManagedObject.ts" />

class TipPoolTag extends TipPoolTag_ManagedObject
{

}
